var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-qr-code",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 3,
    y: 3,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 16,
    y: 3,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 3,
    y: 16,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16h-3a2 2 0 0 0-2 2v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21v.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v3a2 2 0 0 1-2 2H7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.a6c316f8dab8591c7792e9793caf86a6.svg";
export { ForwardRef as ReactComponent };